import React from "react"
import { Link } from "react-router-dom"

function DownloadBtn({ text, navComponents, arabic, english, pdfPath, pdfName, gold, outlined, url, downloadSection, navMenu, navLang, strategyPage }) {

	return (
		// <button
		// 	className={`downloadBtn ${navComponents ? "navDownloadBtn" : ""} ${
		// 		arabic ? "gess-medium" : ""
		// 	}`}
		// >
		// 	{text}
		// </button> 
		<>
		{url ? (
			<Link
			to={url}
			className={`downloadBtn ${navLang ? "navLangBtn" : ""} 
			${arabic ? "arabic" : ""} ${english ? 'english' : ''} ${gold ? 'gold' : ''} ${outlined ? 'outlined' : ''} ${strategyPage ? 'strategy' : ''}`}
		>
			{text}
		</Link>
		):( 
			<a
				href={pdfPath}
				target="_blank"
				rel="noopener noreferrer"
				download={pdfPath}
				className={`downloadBtn ${navLang ? "navLangBtn" : ""} 
				${arabic ? "arabic" : ""}
				${english ? 'english' : ''}
				${gold ? 'gold' : ''} ${outlined ? 'outlined' : ''} ${strategyPage ? 'strategy' : ''}`}
			>
				{(downloadSection || navMenu) && 
					<img className="download-icon" src={process.env.PUBLIC_URL + "/imgs/download-icon.svg"} alt="download-icon" />
				}
				{text}
			</a> 
		)
		}
		</>
			 
	)
}

export default DownloadBtn
